<template>
  <div class="bulkcoupon secondary_title">
    <h4 class="secondary_title">{{$t('detail.buy_more_save_more')}}</h4>
    <div class="bulkBody">
      <div
        class="couponItem"
        v-for="(item, index) in bulk_coupon.discount_rule"
        :key="item.from"
      >
        <div class="couponTips">
          <h5>
            {{ item.from }} {{$t('detail.items_get')}}
            <v-currencysymbol v-if="item.type == 'flat'"></v-currencysymbol
            >{{ item.value }}<span v-if="item.type == 'percentage'">%</span> {{$t('detail.off')}}
          </h5>
          <p>{{$t('detail.on_each_product')}}</p>
        </div>
        <div class="couponButton">
          <div
            class="addToCart"
            v-if="
              item.from == cart_contents_count ||
              (bulk_coupon.discount_rule.length - 1 == index &&
                item.from < cart_contents_count)
            "
          >
            <span class="iconfont">&#xe60f;</span> {{$t('detail.added')}}
          </div>
          <button
            class="addToCart main_button"
            :class="{ button_active: disabled }"
            :disabled="disabled"
            v-if="item.from > cart_contents_count"
            v-show="!disabled || click_index == index"
            @click.prevent="addToCart(item.from, index)"
          >
            {{$t('detail.add_to_cart')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "../../API";
export default {
  props: ["bulk_coupon", "product_id", "variant_id", "cart_type", "product","theme"],
  data() {
    return {
      cartmes: {},
      cart_item: [], //购物车商品
      cart_contents_count: 0,
      has_num: 0, //购物车已有当前商品的数量
      disabled: false,
      click_index: null,
    };
  },
  async beforeMount() {
    try {
      let res = await this.$axios.get(API.addcart);
      this.$store.dispatch("change_news_cart", res.data);
    } catch (error) {}
  },
  methods: {
    async addToCart(from, index) {
      this.disabled = true;
      this.click_index = index;
      try {
        let addproduct = {
          quantity: from - this.has_num,
          product_id: this.product_id,
        };
        if (this.variant_id) {
          addproduct.variant_id = this.variant_id;
        }
        let res = await this.$axios.post(API.addcart, addproduct);
        this.$store.dispatch("change_news_cart", res.data);
        if (this.theme=="Brooklyn"&&this.cart_type == "drawer") {
          this.$store.dispatch("change_cart_type", true);
          this.disabled = false;
        } else if (this.theme=="venue"&&this.cart_type == "popup") {
          this.disabled = false;
          this.$store.dispatch("change_button_disabled", false);
          this.$("#modalCart").modal("show");
        } else {
          window.open("/cart", "_self");
        }
        if (window.fbq) {
          this.FbAddToCart(this.product, addproduct);
        }
        if (window.gtag) {
          window.gtag("event", "add_to_cart");
        }
      } catch (error) {
        this.disabled = false;
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else {
          this.$message.error(error.response.data.message);
        }
      }
    },
  },
  watch: {
    "$store.state.news_cart"(newV) {
      this.cartmes = newV;
      this.cart_item = Object.values(newV.cart);
      this.has_num = 0;
      //   计算购物车已有当前商品的数量，加购时总是以目标数量减去当前商品数
      this.cart_item.forEach((cartitem) => {
        if (cartitem.product_id == this.product_id) {
          this.has_num += cartitem.quantity;
        }
      });
      //   如果购物车是所有都开启梯度优惠，则以购物车所有数量来显示不同梯度的button。若部分商品开启梯度优惠则以该商品的数量显示梯度优惠button
      if (this.bulk_coupon.product_ids.length == 0) {
        this.cart_contents_count = newV.cart_contents_count;
      } else {
        this.cart_contents_count = this.has_num;
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.bulkcoupon {
  margin-top: 20px;
  width: 100%;
  text-align: left;
  h4 {
    color: #141414;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 8;
  }
  .bulkBody {
    .couponItem {
      padding: 8px 16px;
      margin-bottom: 4px;
      display: flex;
      background-color: #f8f8f8;
      justify-content: space-between;
      align-items: center;
      .couponTips {
        h5 {
          margin: 0;
          font-size: 13px;
          line-height: 20px;
          font-weight: 600;
          text-align: left;
          color: #606060;
        }
        p {
          font-size: 12px;
          line-height: 18px;
          font-weight: 400;
          text-align: left;
          color: #bcbcbc;
          margin: 0;
        }
      }
      .couponButton {
        max-width: 50%;
        .addToCart {
          min-width: 100px;
          font-size: 13px;
          text-transform: none;
          letter-spacing: normal;
          text-align: center;
          border-radius: 2px;
          outline: 0;
          border: 1px solid transparent;
          transition: background-color 0.4s ease, border 0.4s ease;
          padding:  8px;
          line-height: 1;
        }
        button {
          font-weight: 400;
          background-color: #26a79a;
          color: #fff;
        }

        & > div {
          font-weight: 600;
          background-color: #eee;
          color: #bcbcbc;
          pointer-events: none;
          span {
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>